import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ResponseStructure } from '@iq-central-front-end/share';
import { Subscription } from 'rxjs';
import { GlobalService } from '../../_services/global.service';
import { MentorshipService } from '../../_services/mentorship.service';
import { NotificationService } from '../../_services/notification.service';
import { StaffService } from '../../_services/staff.service';

@Component({
  selector: 'app-staff-chats',
  templateUrl: './staff-chats.component.html',
  styleUrls: ['./staff-chats.component.scss'],
})
export class StaffChatsComponent implements OnInit {
  emptyMessage: boolean;
  mentors: any[] = [];
  mentorId: any;
  messages: any[] = [];
  filteredMentor: any;
  messageForm: FormGroup;
  sub = new Subscription();

  constructor(
    private messageService: NotificationService,
    private _global: GlobalService,
    private _staffService: StaffService,
    private _formBuilder: FormBuilder
  ) {}

  ngOnInit(): void {
    this, this.initMessageForm();
    this.getAllMessages();
  }

  getAllMessages() {
    this.sub.add(
      this.messageService.getAllMessages().subscribe({
        next: (res) => {
          this.mentors = this.filteredMentor = res['responseResult'].messages;
          console.log(this.mentors);
        },
      })
    );
  }

  setMentor(mentorId, mentees) {
    this.mentorId = mentorId;
    this.messages = mentees;

    const dltCheck = document.querySelectorAll('.dlt-check');
    for (let i = 0; i < dltCheck.length; i++) {
      if (dltCheck[i].classList.contains('bg-white')) {
        dltCheck[i].classList.remove('bg-white');
        dltCheck[i].classList.add('bg-green');
      } else {
        dltCheck[i].classList.remove('bg-green');
        dltCheck[i].classList.add('bg-white');
      }
    }
  }

  filter(query: string) {
    this.mentors = query
      ? this.filteredMentor.filter((c) =>
          c.from?.user.fullName.toLowerCase().includes(query.toLowerCase())
        )
      : this.filteredMentor;
  }

  initMessageForm() {
    this.messageForm = this._formBuilder.group({
      subject: [''],
      content: ['', Validators.required],
    });
  }

  sendMessage(mentorId) {
    this._global.showSpinner();
    const payload = this.messageForm.value;
    this.sub.add(
      this._staffService.sendMessage(payload, mentorId).subscribe({
        next: (res: ResponseStructure) => {
          this.initMessageForm();
          this._global.globalSuccessHandler(res);
        },
      })
    );
  }
}
